
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4165|4740|6141|9061)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
